import React from "react";
import Flex from "../../../components/templates/flex";
import { Icon } from "../../../components/icon";
import { Text, TextSmall } from "../../../components/typography";
import Image from "./image";
import Anchor from "./anchor";
var Item = function (_a) {
    var item = _a.item;
    var publishedAt = item.last_publication_date, data = item.data;
    var title = data.title, description = data.description, url = data.url, image = data.image, label = data.label;
    var imageSrc = image && image.url;
    var dateFormated = new Date(publishedAt);
    return (React.createElement(Flex, { column: true, gap: 2 },
        React.createElement(Flex, { gap: 4 },
            imageSrc && React.createElement(Image, { src: imageSrc, width: "160px" }),
            React.createElement(Flex, { column: true, gap: 2 },
                React.createElement(Text, { strong: true }, title),
                React.createElement(Text, null, description))),
        React.createElement(Flex, { justifyContent: "between", alignItems: "center" },
            React.createElement(TextSmall, null, dateFormated.toLocaleDateString()),
            React.createElement(Anchor, { href: url, target: "_blank", rel: "noopener noreferrer", gap: 1, alignItems: "center" },
                React.createElement(Text, { color: "success", strong: true }, label),
                React.createElement(Icon, { color: "success", rotate: 2, name: "arrow_left" })))));
};
export default Item;
